<section class="page-container">
    <div class="flex items-center justify-between">
        <h1 class="main-heading">Cheque Issue Memo</h1>
        <app-navpath />
    </div>
    <div class="content-container">
        <app-data-form [dataFields]="form" dataName="form" (updateFields_child)="updateFields($event)" />
        <div class="mb-2 flex w-fit gap-1">
            <button class="shorter-btn show-btn" (click)="printStatus()">
                <fa-icon [icon]="faPrint" class="mr-1"></fa-icon>Show Details
            </button>
            <button class="shorter-btn print-btn" (click)="printStatus()" [disabled]="lockBtn">
                <fa-icon [icon]="faPrint" class="mr-1"></fa-icon>Print Cheque
            </button>
            <button class="shorter-btn misc-btn" (click)="printStatus()">
                <fa-icon [icon]="faPrint" class="mr-1"></fa-icon>Report - Invoicing
            </button>
            <button class="shorter-btn clear-btn">
                <fa-icon [icon]="faPrint" class="mr-1"></fa-icon>Clear
            </button>
            <button class="shorter-btn misc-btn" (click)="printStatus()">
                <fa-icon [icon]="faPrint" class="mr-1"></fa-icon>Check All
            </button>
            <button class="shorter-btn misc-btn" (click)="printStatus()">
                <fa-icon [icon]="faPrint" class="mr-1"></fa-icon>Uncheck All
            </button>
        </div>
    </div>
</section>